// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { thumbDown16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-thumb-down': IconThumbDown;
    }
}

/**
 * The icon component for the 'thumbDown' icon
 */
export class IconThumbDown extends Icon {
    public constructor() {
        super(thumbDown16X16);
    }
}

registerIcon('icon-thumb-down', IconThumbDown);
export const iconThumbDownTag = 'nimble-icon-thumb-down';
